import type {
  JoinInstructorContentType,
  JoinInstructorSpot,
} from '../../components/pages/open-knowledge/constants/gtmEventParams';

export const eventNames = {
  VIEW_MY_DASHBOARD: 'view_my_dashboard',
  RESET_USER: 'reset_user',
  VIEW_MY_NOTES: 'view_my_notes',
  CLICK_SHARE_NOTES: 'click_share_notes',
  VIEW_SIGNUP: 'view_signup',
  COMPLETE_SIGNUP: 'complete_signup',
  VIEW_SIGNUP_MAIL_RECEIVED: 'view_signup_mail_received',
  VIEW_SIGNIN_PAGE: 'view_signin_page',
  CLICK_SIGNIN_AT_SIGNIN: 'click_signin_at_signin',
  CLICK_FIND_ID_AT_SIGNIN: 'click_find_id_at_signin',
  CLICK_FIND_PW_AT_SIGNIN: 'click_find_pw_at_signin',
  CLICK_SIGNUP_AT_SIGNIN: 'click_signup_at_signin',
  CLICK_SOCIAL_SIGNUP: 'click_social_signup',
  CLICK_MY_COURSES: 'click_my_courses',
  CLICK_MY_CATEGORY_ACCOUNT: 'click_mycategory_account',
  CLICK_MANAGE_MYCAREER: 'click_manage_mycareer',
  CLICK_DELETE_ACCOUNT: 'click_delete_account',
  CLICK_USER_PROFILE_HUB: 'click_user_profile_hub',
  VIEW_MY_COURSES: 'view_my_courses',
  CLICK_MY_COURSES_CARD: 'click_my_courses_card',
  SEARCH_MY_COURSES: 'search_my_courses',
  SUBMIT_REVIEW_MY_COURSES: 'submit_review_my_courses',
  VIEW_CERTIFICATE: 'view_certificate',
  CLICK_SHARE_CERTIFICATE: 'click_share_certificate',
  VIEW_REVIEW_MODAL: 'view_review_modal',
  VIEW_PROFILE_PAGE: 'view_profile_page',
  CLICK_MORE_INFO: 'click_more_info',
  CLICK_MENTORING_BUTTON: 'click_mentoring_button',
  CLICK_FOLLOW_BUTTON: 'click_follow_button',
  CLICK_REVIEW_PAGE: 'click_review_page',
  DASHBOARD_STUDYCARD_DAILYREVIEW_CLICK: 'Dashboard_Studycard_dailyreview-click',
  DASHBOARD_CERTIFICATES_SHARE_CLICK: 'Dashboard_certificates_share-click',
  DASHBOARD_CERTIFICATES_LINKEDIN_CLICK: 'Dashboard_certificates_linkedin-click',
  DASHBOARD_GO_LATEST_LECTURE: 'click_latest_lecture',
  COMPLETE_CREATE_COURSE: 'complete_create_course',
  VIEW_CERT_INTEGRATED_MODAL: 'view_cert_integrated_modal',
  ADD_TO_CART: 'add_to_cart',
  ADD_TO_LIKE: 'add_to_like',
  VIEW_MENTORING_MENTEE_PAGE: 'view_mentoring_mentee_page',
  CLICK_MENTORING_MENTEE_DETAIL_INFO: 'click_mentoring_mentee_detail_info',
  VIEW_MENTORING_MENTOR_DETAIL_PAGE: 'view_mentoring_mentor_detail_page',
  CLICK_MENTORING_MENTEE_CANCEL: 'click_mentoring_mentee_cancel',
  CLICK_MENTORING_MENTEE_WRITE_REVIEW: 'click_mentoring_mentee_write_review',
  CLICK_MENTORING_MENTEE_VIEW_REVIEW: 'click_mentoring_mentee_view_review',
  CLICK_MENTORING_MENTEE_ENTER_LIVE: 'click_mentoring_mentee_enter_live',
  CLICK_MENTORING_MENTEE_VIEW_SUMMARY: 'click_mentoring_mentee_view_summary',

  // AI 소개 생성
  CLICK_SAVE_PROFILE_INTRODUCTION: 'click_save_profile_introduction',

  // 파트너스
  CLICK_PARTNERS_TERMS_LINK: 'click_partners_terms_link',
  CLICK_PARTNERS_TERMS_AGREE: 'click_partners_terms_agree',
  CLICK_PARTNERS_TERMS_FINAL_AGREE: 'click_partners_terms_final_agree',
  CLICK_PARTNERS_JOIN_BUTTON: 'click_partners_join_button',
  CLICK_COURSE_ON_PARTNERS_JOIN_COMPLETE: 'click_course_on_partners_join_complete',
  CLICK_GUIDE_ON_PARTNERS_JOIN_COMPLETE: 'click_guide_on_partners_join_complete',
  CLICK_PARTNERS_SHARE_LINK_ON_MYCOURSES: 'click_partners_share_link_on_mycourses',
  VIEW_PARTNERS_INCOME: 'view_partners_income',
  CLICK_TAB_ON_PARTNERS_INCOME: 'click_tab_on_partners_income',
  CLICK_PAYMENT_REQUEST_ON_PARTNERS_INCOME: 'click_payment_request_on_partners_income',
  COMPLETE_PAYMENT_REQUEST_ON_PARTNERS_INCOME: 'complete_payment_request_on_partners_income',
  VIEW_PARTNERS_LINKS: 'view_partners_links',
  VIEW_PARTNERS_LINKS_SEARCH: 'view_partners_links_search',
  CLICK_PARTNERS_SHARE_LINK: 'click_partners_share_link',

  // 선물하기
  VIEW_SEND_BOX: 'view_send_box',
  VIEW_RECEIVE_BOX: 'view_receive_box',

  // 기기 관리
  VIEW_MY_DEVICE: 'view_my_device',
  CLICK_RECENT_MY_DEVICE: 'click_recent_my_device',

  // 선물 조르기 결제 완료 알림톡 인입 시 노출 모달 내 바로 학습 버튼 클릭 시
  CLICK_VIEW_MYCOURSES: 'click_view_mycourses',

  // 지식공유 참여
  VIEW_JOIN_INSTRUCTOR: 'view_join_instructor',
  CLICK_JOIN_INSTRUCTOR: 'click_join_instructor',
  CLICK_JOIN_INSTRUCTOR_CONTENT: 'click_join_instructor_content',

  // 모의면접
  VIEW_MOCK_INTERVIEW: 'view_mock_interview',
  SCROLL_MOCK_INTERVIEW: 'scroll_mock_interview',
  CLICK_BUTTON_AT_MOCK_INTERVIEW: 'click_button_at_mock_interview',

  // 휴대폰 인증 (@inflearn/modals VerifyPhoneModal과 같은 이벤트명으로 집계한다)
  COMPLETE_PHONE_AUTH: 'complete_phone_auth',

  // AX 수요자 랜딩(/ax/clients)과 견적서 받기(/ax/clients/quote). 어느 화면인지는 variant로 가른다.
  VIEW_AX_LANDING: 'view_ax_landing',
  SCROLL_AX_LANDING_DEPTH: 'scroll_ax_landing_depth',
  CLICK_AX_QUOTE_OPEN: 'click_ax_quote_open',
  COMPLETE_AX_QUOTE: 'complete_ax_quote',

  // 상품 구매 페이지 (인재개발플랫폼 구독권 /partner/subscription/mpm)
  VIEW_PRODUCT_PURCHASE_PAGE: 'view_product_purchase_page',
  SCROLL_PRODUCT_PURCHASE_PAGE_DEPTH: 'scroll_product_purchase_page_depth',
  CLICK_BUTTON_AT_PRODUCT_PURCHASE_PAGE: 'click_button_at_product_purchase_page',
} as const;

type ProductPurchasePageEventProps = {
  product_id: string | null;
  product_title: '인재개발원1개월구독권';
  product_type: 'b2b_subscription';
};

export type EventNames = (typeof eventNames)[keyof typeof eventNames];

export interface EventPropsMap extends Record<EventNames, Record<string, unknown>> {
  [eventNames.VIEW_MY_NOTES]: {
    course_identification: string;
    note_count: number;
    is_public: boolean;
  };
  [eventNames.CLICK_SHARE_NOTES]: {
    course_identification: string;
    note_count: number;
  };
  [eventNames.CLICK_SIGNUP_AT_SIGNIN]: {
    spot: 'page' | 'modal';
  };
  [eventNames.VIEW_MY_COURSES]: {
    course_identification: number[];
    course_title: string[];
    course_type: 'on' | 'off' | 'challenge';
    seq0_instructor_id: number[];
    seq0_instructor_name: string[];
    course_limit_at: string[];
    progress: number[];
    course_count: number;
  };
  [eventNames.CLICK_MY_COURSES_CARD]: {
    course_identification: number;
    course_title: string;
    course_type: 'on' | 'off' | 'challenge';
    seq0_instructor_id: number;
    seq0_instructor_name: string;
    course_limit_at: string;
    progress: number;
    sorting_my_courses: string;
    my_courses_keyword: string;
    filter_my_courses: string[];
    click_spot: 'thumbnail' | 'title';
  };
  [eventNames.SEARCH_MY_COURSES]: {
    search_keyword: string;
    sorting_my_courses: string;
    filter_my_courses: string[];
    course_identification: number[];
    course_count: number;
  };
  [eventNames.SUBMIT_REVIEW_MY_COURSES]: {
    course_identification: number;
    unit_review_tag: string[];
    my_star_rate: number;
    review_body: string;
    progress: number;
    star_rate: number | null;
    course_type: 'on' | 'off' | 'challenge';
  };
  [eventNames.VIEW_CERTIFICATE]: {
    click_spot: 'mycourses' | 'user_dashboard' | 'certificates';
  };
  [eventNames.CLICK_SHARE_CERTIFICATE]: {
    type: 'linkedin' | 'linkcopy' | 'download';
  };
  [eventNames.VIEW_REVIEW_MODAL]: {
    title: string;
    progress: number;
    course_limited_at: string;
    course_identification: number;
    click_spot: 'dashboard' | 'unit' | 'mycourses' | 'course_detail';
    my_star_rate: number | null;
  };
  [eventNames.VIEW_PROFILE_PAGE]: {
    user_identification: string;
    is_instructor: boolean;
    has_infcon_coupon: boolean;
    is_infcon_registered: boolean;
  };
  [eventNames.CLICK_MORE_INFO]: {
    user_identification: string;
    is_instructor: boolean;
    more_view: boolean; // 더보기 접기 여부
  };
  [eventNames.CLICK_MENTORING_BUTTON]: {
    user_identification: string;
  };
  [eventNames.CLICK_FOLLOW_BUTTON]: {
    user_identification: string;
    is_instructor: boolean;
    is_following: boolean;
  };
  [eventNames.CLICK_REVIEW_PAGE]: {
    click_spot: string;
    review_id: string;
    review_description: string;
    review_score: number;
    like_count: number;
    review_user_name: string;
    review_user_id: string;
    course_identification: string;
    course_title: string;
  };
  [eventNames.CLICK_MY_COURSES]: {
    entry_point: 'LNB' | 'Hover' | 'Main 내학습 타이틀' | '기타';
  };
  [eventNames.DASHBOARD_GO_LATEST_LECTURE]: {
    entry_point: 'GNB 최근강의' | 'Hover' | 'Main 내학습 카드' | '기타';
  };
  [eventNames.DASHBOARD_CERTIFICATES_LINKEDIN_CLICK]: {
    user_id: number;
  };
  [eventNames.DASHBOARD_CERTIFICATES_SHARE_CLICK]: {
    user_id: number;
  };
  [eventNames.COMPLETE_CREATE_COURSE]: {
    course_identification: number;
    course_title: string;
    course_price_type: string;
    course_type: string;
  };
  [eventNames.VIEW_CERT_INTEGRATED_MODAL]: {
    user_id: number;
    user_name: string;
    click_spot: 'users_dashboard' | 'users_profile_header';
  };
  [eventNames.CLICK_MENTORING_MENTEE_DETAIL_INFO]: {
    mentoring_status: string;
    mentoring_title: string;
    mentoring_name: string;
    mentoring_started_at: string;
    mentoring_ended_at: string;
    mentoring_payment: string;
  };
  [eventNames.VIEW_MENTORING_MENTOR_DETAIL_PAGE]: {
    mentoring_status: string;
    mentoring_title: string;
    mentoring_name: string;
    mentoring_started_at: string;
    mentoring_ended_at: string;
    mentoring_payment: string;
  };
  [eventNames.CLICK_MENTORING_MENTEE_CANCEL]: {
    mentoring_status: string;
    mentoring_title: string;
    mentoring_name: string;
    mentoring_started_at: string;
    mentoring_ended_at: string;
    mentoring_payment: string;
  };
  [eventNames.CLICK_MENTORING_MENTEE_WRITE_REVIEW]: {
    mentoring_status: string;
    mentoring_title: string;
    mentoring_name: string;
    mentoring_started_at: string;
    mentoring_ended_at: string;
    mentoring_payment: string;
  };
  [eventNames.CLICK_MENTORING_MENTEE_VIEW_REVIEW]: {
    mentoring_status: string;
    mentoring_title: string;
    mentoring_name: string;
    mentoring_started_at: string;
    mentoring_ended_at: string;
    mentoring_payment: string;
  };
  [eventNames.CLICK_MENTORING_MENTEE_ENTER_LIVE]: {
    mentoring_status: string;
    mentoring_title: string;
    mentoring_name: string;
    mentoring_started_at: string;
    mentoring_ended_at: string;
    mentoring_payment: string;
  };
  [eventNames.CLICK_MENTORING_MENTEE_VIEW_SUMMARY]: {
    mentoring_status: string;
    mentoring_title: string;
    mentoring_name: string;
    mentoring_started_at: string;
    mentoring_ended_at: string;
    mentoring_payment: string;
  };
  [eventNames.CLICK_PARTNERS_JOIN_BUTTON]: {
    marketing_partner_type: 'business' | 'personal';
    name: string;
    email: string;
    country_code: string;
    phone_number: string;
  };
  [eventNames.CLICK_COURSE_ON_PARTNERS_JOIN_COMPLETE]: {
    marketing_partner_type: 'business' | 'personal';
    name: string;
    email: string;
    country_code: string;
    phone_number: string;
    button_link: string;
    partner_id: string;
    commission_rate: { agreed: number; disagreed: number };
  };
  [eventNames.CLICK_GUIDE_ON_PARTNERS_JOIN_COMPLETE]: {
    marketing_partner_type: 'business' | 'personal';
    name: string;
    email: string;
    country_code: string;
    phone_number: string;
    button_link: string;
    partner_id: string;
    commission_rate: { agreed: number; disagreed: number };
  };
  [eventNames.CLICK_PARTNERS_SHARE_LINK_ON_MYCOURSES]: {
    course_identification: string;
    course_title: string;
    seq0_instructor_id: string;
    seq0_instructor_name: string;
    course_limit_at: string;
    progress: number;
  };
  [eventNames.VIEW_PARTNERS_INCOME]: {
    partners_id: string;
    is_submit: boolean;
    marketing_partner_type: 'business' | 'personal';
  };
  [eventNames.CLICK_TAB_ON_PARTNERS_INCOME]: {
    partners_id: string;
    spot: 'revenue' | 'settlement';
    marketing_partner_type: 'business' | 'personal';
  };
  [eventNames.CLICK_PAYMENT_REQUEST_ON_PARTNERS_INCOME]: {
    partners_id: string;
    request_amount: number;
    marketing_partner_type: 'business' | 'personal';
  };
  [eventNames.COMPLETE_PAYMENT_REQUEST_ON_PARTNERS_INCOME]: {
    partners_id: string;
    request_amount: number;
    marketing_partner_type: 'business' | 'personal';
  };

  [eventNames.VIEW_SEND_BOX]: {
    count: number;
  };
  [eventNames.VIEW_RECEIVE_BOX]: {
    count: number;
  };
  [eventNames.VIEW_PARTNERS_LINKS]: {
    partner_id: string;
    marketing_partner_type: 'business' | 'personal';
    is_submit: boolean;
  };
  [eventNames.CLICK_PARTNERS_SHARE_LINK]: {
    course_identification: string;
    course_title: string;
    first_category: string[];
    second_category: string[];
    skill_tag: string[];
    reg_price: number;
    reg_vat_price: number;
    selling_price: number;
    is_discount: boolean;
    discount_title: string;
    discount_rate: number;
    partner_id: string;
    marketing_partner_type: 'business' | 'personal';
    commission_rate: string;
  };
  [eventNames.VIEW_PARTNERS_LINKS_SEARCH]: {
    search_keyword: string;
    search_result_count: number;
    sorting_course: string;
    category_course: string;
  };
  [eventNames.VIEW_MY_DEVICE]: {
    device_count: string;
    spot: 'lecture' | 'direct';
  };
  [eventNames.CLICK_RECENT_MY_DEVICE]: {
    device_count: string;
  };
  [eventNames.CLICK_JOIN_INSTRUCTOR]: {
    spot: JoinInstructorSpot;
  };
  [eventNames.CLICK_JOIN_INSTRUCTOR_CONTENT]: {
    content_type: JoinInstructorContentType;
    content_name?: string;
  };
  [eventNames.VIEW_MOCK_INTERVIEW]: {
    entry_point:
      | 'header_service_menu'
      | 'header_profile_menu'
      | 'profile'
      | 'my_courses'
      | 'community'
      | 'mentoring_list'
      | 'main_banner'
      | 'my_ai_interviews'
      | 'threads'
      | 'direct';
  };
  [eventNames.SCROLL_MOCK_INTERVIEW]: {
    depth_percent: number;
  };
  [eventNames.CLICK_BUTTON_AT_MOCK_INTERVIEW]: {
    label:
      | '모의면접 시작하기'
      | '모의면접 이어하기'
      | '보고서 보러가기'
      | '무료 면접 시작하기'
      | '다시 도전하기'
      | '모의면접 응시하기';
  };
  [eventNames.COMPLETE_PHONE_AUTH]: {
    spot: string;
  };
  [eventNames.VIEW_AX_LANDING]: {
    variant: string;
  };
  [eventNames.SCROLL_AX_LANDING_DEPTH]: {
    variant: string;
    depth: number;
  };
  [eventNames.CLICK_AX_QUOTE_OPEN]: {
    variant: string;
    spot: string;
  };
  [eventNames.VIEW_PRODUCT_PURCHASE_PAGE]: ProductPurchasePageEventProps;
  [eventNames.SCROLL_PRODUCT_PURCHASE_PAGE_DEPTH]: ProductPurchasePageEventProps & {
    depth_percent: number;
  };
  [eventNames.CLICK_BUTTON_AT_PRODUCT_PURCHASE_PAGE]: ProductPurchasePageEventProps & {
    spot: 'top' | 'floating' | 'header' | 'top10' | 'ai_curation';
    label: '구독권 구매' | '인프런 소개' | '인프런 로고' | '강의카드' | '구독 강의 전체 보기';
    content_identification?: number;
    content_title?: string;
  };
}
